import type { SVGProps } from "react";
import { cn } from "../lib/cn";

export interface SpinnerProps extends Omit<SVGProps<SVGSVGElement>, "children"> {
  /** 14 | 16 | 20 px. Padrão 16. */
  size?: 14 | 16 | 20 | 24;
  /** Nome acessível. Se `decorative`, é ignorado. */
  label?: string;
  /** Quando já existe texto "Conectando..." ao lado, o svg vira decoração. */
  decorative?: boolean;
}

/**
 * USO RESTRITO.
 *
 * Loading de conteúdo é SEMPRE `Skeleton` no formato final
 * (DESIGN_SYSTEM seção 1.6 — spinner central é proibido).
 * Este componente existe para dois casos só:
 *   1. estado `CONNECTING` do monitorador (seção 8), ao lado do rótulo;
 *   2. ação em andamento sem área de conteúdo (ex.: dentro de um Toast).
 */
export function Spinner({
  size = 16,
  label = "Carregando",
  decorative = false,
  className,
  ...props
}: SpinnerProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      role={decorative ? "presentation" : "status"}
      aria-hidden={decorative ? "true" : undefined}
      aria-label={decorative ? undefined : label}
      className={cn(
        "shrink-0 animate-spin [animation-duration:1.2s]",
        "motion-reduce:animate-none",
        className,
      )}
      {...props}
    >
      <circle cx="12" cy="12" r="9" className="opacity-25" />
      <path d="M21 12a9 9 0 0 0-9-9" />
    </svg>
  );
}
